import React, { FC, useContext, memo } from 'react';
import { useTranslation } from 'react-i18next';

import SongsDjView from './views/SongsDjView';
import SongsGuestView from './views/SongsGuestView';
import WithEventRole from 'components/user/WithEventRole';
import NoSongsFound from 'components/emptyStates/NoSongsFound';

import { TimelineSongsContext } from '../TimelineSongsContext';

import { EventUserType } from 'types/enums';
import { SongsListProps } from './interfaces';

const SongsList: FC<SongsListProps> = ({ ...rest }) => {
  const { t } = useTranslation();

  const { songsOptions } = useContext(TimelineSongsContext);

  return (
    <>
      <WithEventRole roles={[EventUserType.guest]}>
        <SongsGuestView {...rest} />
      </WithEventRole>
      <WithEventRole roles={[EventUserType.dj, EventUserType.host]}>
        <SongsDjView {...rest} />
      </WithEventRole>
      {songsOptions.songsList.length ? null : <NoSongsFound>{t('noSongsFound')}</NoSongsFound>}
    </>
  );
};

export default memo(SongsList);
